import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { useTranslation } from 'react-i18next';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(6),
    backgroundColor: "#171717",
    textAlign: "center"
  },
  typo: {
    color: "#cccccc"
  },
  box: {
    display: "inline"
  },
  social: {
    width: "24px",
    height: "24px",
    marginRight: "5px"
  }
});

const PiePagina = props => {
  const { classes } = props;
  const { t } = useTranslation(['translation', 'pagos']);
  const urlIn = "https://www.linkedin.com/company/atel-guatemala/";
  const urlYt = "https://www.youtube.com/channel/UCzMdxciKbcJW2PrY85QurMQ";

  return (
    <React.Fragment>
      <footer className={classes.root}>
        <Typography
          inline="true"
          className={classes.typo}
          variant="body2"
          align="center"
          gutterBottom
        >
          <Link href={urlIn} target="_blank" rel="noreferrer">
            <svg
              className={classes.social}
              style={{ marginBottom: 2 }}
              viewBox="0 0 24 24"
            >
              <path
                fill="#cccccc"
                d="M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z"
              />
            </svg>
          </Link>
          <Link href={urlYt} target="_blank" rel="noreferrer">
            <svg
              className={classes.social}
              style={{ marginBottom: 0 }}
              viewBox="0 0 24 24"
            >
              <path
                fill="#cccccc"
                d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
              />
            </svg>
          </Link>
          <br />
          {t('pagos:contactanos')} :<span> </span>
          <Box
            fontWeight={600}
            className={classes.box}
            textAlign="center"
            component="span"
          >
            +1 650 7302080
          </Box>

        </Typography>
      </footer>
    </React.Fragment>
  );
};

PiePagina.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PiePagina);
